var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSale = function SvgSale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.217 4.46 5.294.54A.417.417 0 0 0 5 .417H.833a.417.417 0 0 0-.416.416V5c0 .11.044.216.122.295L4.46 9.217a1.25 1.25 0 0 0 1.768 0L9.217 6.23a1.25 1.25 0 0 0 0-1.768Zm-5.884-.293a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z",
    fill: "#000"
  })));
};

export default SvgSale;